import { useContext } from "@nuxtjs/composition-api";

export function useServiceTypeActions() {
  const { $mutate, $query } = useContext();

  async function saveServiceType(submitData) {
    try {
      if (submitData.id !== null) {
        const UPDATE_SUBSCRIPTION_ITEM_TYPE = await import(
          "./updateServiceType.graphql"
        );
        return await $mutate(UPDATE_SUBSCRIPTION_ITEM_TYPE, submitData);
      } else {
        const CREATE_SUBSCRIPTION_ITEM_TYPE = await import(
          "./createServiceType.graphql"
        );
        return await $mutate(CREATE_SUBSCRIPTION_ITEM_TYPE, submitData);
      }
    } catch (e) {
      console.error(e);
      return Promise.reject(e);
    }
  }

  async function deleteServiceTypeById(id) {
    try {
      const DELETE_SUBSCRIPTION_ITEM_TYPE = await import(
        "./deleteServiceTypeById.graphql"
      );
      await $mutate(
        DELETE_SUBSCRIPTION_ITEM_TYPE,
        { id },
        { showErrorToast: true }
      );
    } catch (e) {
      console.error(e);
      return Promise.reject(e);
    }
  }

  async function getServiceTypeById(id) {
    try {
      const GET_SUBSCRIPTION_ITEM_TYPE = await import(
        "./getServiceTypeById.graphql"
      );
      const { serviceTypeById } = await $query(GET_SUBSCRIPTION_ITEM_TYPE, {
        id,
      });
      return serviceTypeById;
    } catch (e) {
      console.error(e);
      return Promise.reject(e);
    }
  }

  async function getServiceTypes(params) {
    try {
      const GET_SUBSCRIPTION_ITEM_TYPES = await import(
        "./serviceTypesDataTable.graphql"
      );
      const { serviceTypesDataTable } = await $query(
        GET_SUBSCRIPTION_ITEM_TYPES,
        params
      );
      return serviceTypesDataTable;
    } catch (e) {
      console.error(e);
      return Promise.reject(e);
    }
  }

  return {
    saveServiceType,
    deleteServiceTypeById,
    getServiceTypeById,
    getServiceTypes,
  };
}
